var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditAiEffect(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2l1.5 4.5L15.5 8l-4.5 1.5L9.5 14 8 9.5 3.5 8 8 6.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 9l1 3 3 1-3 1-1 3-1-3-3-1 3-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 17l.75 2.25L17.5 20l-2.25.75L14.5 23l-.75-2.25L11.5 20l2.25-.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAiEffect);
export default __webpack_public_path__ + "static/media/edit-ai-effect.c39f1614c2bb3498edef1716246a77b9.svg";
export { ForwardRef as ReactComponent };